import AzBackToTopButton from '~/components/_next/atoms/AzBackToTopButton';
export default defineComponent({
  name: 'ProductBottomNavigation',
  components: {
    AzBackToTopButton: AzBackToTopButton
  },
  props: {
    breadcrumbs: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup(props) {
    var isBreadcrumbsProvided = computed(function () {
      return props.breadcrumbs.length > 0;
    });
    return {
      isBreadcrumbsProvided: isBreadcrumbsProvided
    };
  }
});